export default __webpack_public_path__ + "static/Moodbe-710742eee28ce9861451564efbd9ad83.webp";